import script from "./TraceMatrixContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TraceMatrixContent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
